import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {environment} from 'src/main/resources/static/angular2/environments/environment';

import {User} from '../models/User.model';
import {UserAuthResponse} from '../models/UserAuthResponse.model';
import {DomainNameParserService} from '../../shared/services/domain-name-parser.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private domainNameParserService: DomainNameParserService) {
    this.accessManagerHost = environment.accessManager.host[domainNameParserService.getState()];
  }

  private readonly accessManagerHost;
  private readonly AUTHENTICATE_PATH = '/json/realms/dearborn/authenticate';

  authenticate(user: User): Observable<UserAuthResponse> {
    return this.http.post<UserAuthResponse>("cidm/login", user,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Accept-API-Version', 'resource=2.0, protocol=1.0'),
      });
  }

  private getAuthenticateUrl(): string {
    return this.accessManagerHost + this.AUTHENTICATE_PATH;
  }
}
